import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(decodeURIComponent(TokenKey) )
}

export function setToken(token) {
  return Cookies.set(TokenKey, encodeURIComponent(token))
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
